import type { ShowcaseProduct } from "../../../pages/ShowcasePage/types";
import { Text, Box, Flex } from "@simplybusiness/mobius";

export interface ShowcaseProductsListTreatmentEmbeddedQuickRepliesProps {
  products: ShowcaseProduct[];
}

export const ShowcaseProductsListTreatmentEmbeddedQuickReplies = ({
  products,
}: ShowcaseProductsListTreatmentEmbeddedQuickRepliesProps) => (
  <Box
    className="mobius-showcase-products-list"
    data-testid="mobius-showcase-products-list"
  >
    {products.map((product, index) => (
      <Flex
        key={index}
        className="mobius-showcase-product-list__item"
        gap="xxs"
        flexDirection="column"
      >
        <Text className="mobius-title__header mobius-product-list__item-title">
          {product.productDisplayName}
        </Text>
        {[product.coverageLimit].flat().map((limit, limitIndex) => (
          <Text
            key={limitIndex}
            elementType="p"
            className="mobius-title__description mobius-product-list__coverage-limit"
          >
            {limit}
            <sup>&dagger;</sup>
          </Text>
        ))}
      </Flex>
    ))}
  </Box>
);
